import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import Alert from '../../Alert';
import TableComponent from '../../TableComponent';
import OrderCard from '../../OrderCard';
import SectionTitle from '../../SectionTitle';
import Skeleton from '@mui/material/Skeleton';

// Styles
import styles from './index.module.sass';
import getFacturas from '../../Queries/getFacturas';

const Invoices = (props) => {
  const { device, setSessionMessage } = props;
  const { screenSize } = device;
  const { t } = useTranslation('invoices');
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const invoicesItems = t('invoises', { returnObjects: true });

  useEffect(() => {
    async function invoices() {
      setLoading(true);
      const response = await getFacturas();
      const { tipoMensaje = 'error', facturas = [], mensaje = '' } = response;
      setSessionMessage(mensaje);

      if (mensaje !== '' || tipoMensaje === 'error') {
        setAlertText(mensaje);
        setOpen(true);
      } else {
        setInvoices(facturas);
      }
      setLoading(false);
    }
    invoices();
  }, [setSessionMessage]);

  return (
    <div id={styles.invoices} className={`${styles[screenSize]} ${styles.invoices}`}>
      <Alert open={open} setOpen={setOpen} title={t('alertTitle')} text={alertText} />
      <SectionTitle title={t('title')} subtitle={t('subTitle')} />
      <div className={styles.container}>
        <OrderCard>
          {(loading && (
            <div>
              <TableComponent
                screenSize={screenSize}
                tableData={invoices}
                tableItems={invoicesItems}
              />
              <Skeleton variant='rectangular' className={styles.loadingText} />
              <Skeleton variant='rectangular' className={styles.loadingText} />
              <Skeleton variant='rectangular' className={styles.loadingText} />
            </div>
          )) || (
            <TableComponent
              screenSize={screenSize}
              tableData={invoices}
              tableItems={invoicesItems}
            />
          )}
        </OrderCard>
      </div>
    </div>
  );
};

export default Invoices;
